module.exports = __webpack_public_path__ + "static/img/app.17983b9.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/productimg/app.png
// module id = AsY8
// module chunks = 0